import { render, staticRenderFns } from "./newsRelease.vue?vue&type=template&id=9e74eb04&scoped=true&"
import script from "./newsRelease.vue?vue&type=script&lang=js&"
export * from "./newsRelease.vue?vue&type=script&lang=js&"
import style0 from "./newsRelease.vue?vue&type=style&index=0&id=9e74eb04&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e74eb04",
  null
  
)

export default component.exports